<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(submit)">
      <div class="row custom-row">
        <div class="col-1"></div>
        <div class="col-10 mr-auto">
          <h4 style="color:white; text-align: center;">{{ $t('app.modules.register.title') }}</h4>

          <div class="row">
            <div class="col-1"></div>
            <div class="col-10">
              <card class="card-signup text-center" no-footer-line>
                <div class="row text-left">
                  <div :class="sizes">
                    <ValidationProvider
                      :name="$t('app.modules.candidates.headers.business_name')"
                      rules=""
                      v-slot="{ passed, failed }"
                    >
                      <fg-input
                        type="text"
                        :error="failed ? required_text : null"
                        :hasSuccess="passed"
                        :placeholder="
                      $t('app.modules.candidates.headers.business_name')
                    "
                        :label="$t('app.modules.candidates.headers.business_name')"
                        v-model="payload.prospecto.razonSocial"
                      >
                      </fg-input>
                    </ValidationProvider>
                  </div>

                  <div :class="sizes">
                    <ValidationProvider
                      :name="$t('app.modules.candidates.headers.rfc')"
                      rules=""
                      v-slot="{ passed, failed }"
                    >
                      <fg-input
                        type="text"
                        :error="failed ? required_text : null"
                        :hasSuccess="passed"
                        :placeholder="$t('app.modules.candidates.headers.rfc')"
                        :label="$t('app.modules.candidates.headers.rfc')"
                        v-model="payload.prospecto.rfc"
                      >
                      </fg-input>
                    </ValidationProvider>
                  </div>

                  <div :class="sizes">
                    <ValidationProvider
                      :name="$t('app.modules.candidates.headers.company')"
                      rules="required"
                      v-slot="{ passed, failed }"
                    >
                      <fg-input
                        type="text"
                        :error="failed ? required_text : null"
                        :hasSuccess="passed"
                        :placeholder="$t('app.modules.candidates.headers.company')"
                        :label="$t('app.modules.candidates.headers.company')"
                        v-model="payload.prospecto.compañia"
                      >
                      </fg-input>
                    </ValidationProvider>
                  </div>

                  <div :class="sizes">
                    <ValidationProvider
                      :name="$t('app.modules.candidates.headers.applicants_name')"
                      rules="required"
                      v-slot="{ passed, failed }"
                    >
                      <fg-input
                        type="text"
                        :error="failed ? required_text : null"
                        :hasSuccess="passed"
                        :placeholder="
                      $t('app.modules.candidates.headers.applicants_name')
                    "
                        :label="
                      $t('app.modules.candidates.headers.applicants_name')
                    "
                        v-model="payload.prospecto.nombreContacto"
                      >
                      </fg-input>
                    </ValidationProvider>
                  </div>
                  <div :class="sizes">
                    <ValidationProvider
                      :name="$t('app.modules.candidates.headers.country')"
                      rules="required"
                      v-slot="{ passed, failed }"
                    >
                      <fg-input
                        type="text"
                        :error="failed ? required_text : null"
                        :hasSuccess="passed"
                        :placeholder="$t('app.modules.candidates.headers.country')"
                        :label="$t('app.modules.candidates.headers.country')"
                        v-model="payload.prospecto.pais"
                      >
                      </fg-input>
                    </ValidationProvider>
                  </div>
                  <div :class="sizes">
                    <ValidationProvider
                      :name="$t('app.modules.candidates.headers.state')"
                      rules="required"
                      v-slot="{ passed, failed }"
                    >
                      <fg-input
                        type="text"
                        :error="failed ? required_text : null"
                        :hasSuccess="passed"
                        :placeholder="$t('app.modules.candidates.headers.state')"
                        :label="$t('app.modules.candidates.headers.state')"
                        v-model="payload.prospecto.estado"
                      >
                      </fg-input>
                    </ValidationProvider>
                  </div>
                  <div :class="sizes">
                    <ValidationProvider
                      :name="$t('app.modules.candidates.headers.phone')"
                      rules="required"
                      v-slot="{ passed, failed }"
                    >
                      <fg-input
                        type="text"
                        :error="failed ? required_text : null"
                        :hasSuccess="passed"
                        :placeholder="$t('app.modules.candidates.headers.phone')"
                        :label="$t('app.modules.candidates.headers.phone')"
                        v-model="payload.prospecto.telefono"
                      >
                      </fg-input>
                    </ValidationProvider>
                  </div>
                  <div :class="sizes">
                    <ValidationProvider
                      :name="$t('app.modules.candidates.headers.mail')"
                      rules="required|email"
                      v-slot="{ passed, failed }"
                    >
                      <fg-input
                        type="email"
                        :error="failed ? required_text : null"
                        :hasSuccess="passed"
                        :placeholder="$t('app.modules.candidates.headers.mail')"
                        :label="$t('app.modules.candidates.headers.mail')"
                        v-model="payload.prospecto.email"
                      >
                      </fg-input>
                    </ValidationProvider>
                  </div>
                  <div :class="sizes">
                    <ValidationProvider
                      :name="
                    $t('app.modules.candidates.headers.interested_product')
                  "
                      rules="required"
                      v-slot="{ passed, failed }"
                    >
                      <fg-input
                        type="text"
                        :error="failed ? required_text : null"
                        :hasSuccess="passed"
                        :placeholder="
                      $t('app.modules.candidates.headers.interested_product')
                    "
                        :label="
                      $t('app.modules.candidates.headers.interested_product')
                    "
                        v-model="payload.prospecto.productoInteres"
                      >
                      </fg-input>
                    </ValidationProvider>
                  </div>
                  <div :class="sizes">
                    <ValidationProvider
                      :name="$t('app.modules.candidates.headers.quantity')"
                      rules="required"
                      v-slot="{ passed, failed }"
                    >
                      <fg-input
                        type="text"
                        :error="failed ? required_text : null"
                        :hasSuccess="passed"
                        :placeholder="$t('app.modules.candidates.headers.quantity')"
                        :label="$t('app.modules.candidates.headers.quantity')"
                        v-model="payload.prospecto.cantidad"
                      >
                      </fg-input>
                    </ValidationProvider>
                  </div>
                  <div :class="sizes">
                    <ValidationProvider
                      :name="$t('app.modules.candidates.headers.commentary')"
                      rules=""
                      v-slot="{ passed, failed }"
                    >
                      <fg-input
                        type="text"
                        :error="failed ? required_text : null"
                        :hasSuccess="passed"
                        :placeholder="
                      $t('app.modules.candidates.headers.commentary')
                    "
                        :label="$t('app.modules.candidates.headers.commentary')"
                        v-model="payload.prospecto.comentarios"
                      >
                      </fg-input>
                    </ValidationProvider>
                  </div>
                </div>
                <n-button slot="footer" type="primary" native-type="submit" round>
                  {{ $t("app.buttons.register") }}
                </n-button>

                <!--<div v-if="correctSave" class="alert alert-success">
                  <button type="button" aria-hidden="true" class="close">
                    <i class="now-ui-icons ui-1_simple-remove"></i>
                  </button>
                  <span>{{
                      $t("app.modules.candidates.headers.register_correct")
                    }}</span>
                </div>
                <div v-if="trubbleSave" class="alert alert-danger">
                  <button type="button" aria-hidden="true" class="close">
                    <i class="now-ui-icons ui-1_simple-remove"></i>
                  </button>
                  <span>{{
                      $t("app.modules.candidates.headers.register_incorrect")
                    }}</span>
                </div>-->
              </card>
            </div>
            <div class="col-1"></div>
          </div>


        </div>
        <div class="col-1"></div>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      required_text: this.$t("app.general.required"),
      correctSave: false,
      trubbleSave: false,
      payload: {
        id: 0,
        claveIdioma: "es",
        usuario: 0,
        prospecto: {
          idProspecto: 0,
          razonSocial: "",
          rfc: "",
          compañia: "",
          nombreContacto: "",
          pais: "",
          estado: "",
          telefono: "",
          email: "",
          productoInteres: "",
          cantidad: "",
          comentarios: "",
          fechaEnvio: "2020-10-27T17:31:28.486Z",
          fechaAsignacion: "2020-10-27T17:31:28.486Z",
          ejecutivoAsignado: 0,
          prospectoStatus: 1,
          motivoRechazo: "",
          notificacionMail: true
        }
      },
      sizes: "col-md-6 col-sm-12",
      email: "",
      firstName: "",
      lastName: "",
      agree: false
    };
  },
  mounted() {},
  methods: {
    getDatetime() {
      var pad2 = function(num) {
        return ("00" + num).slice(-2);
      };
      var dt = new Date();
      var dtstring =
        dt.getFullYear() +
        "-" +
        pad2(dt.getMonth() + 1) +
        "-" +
        pad2(dt.getDate()) +
        " " +
        pad2(dt.getHours()) +
        ":" +
        pad2(dt.getMinutes()) +
        ":" +
        pad2(dt.getSeconds());
      return dtstring;
    },
    async register() {
      let isValidForm = await this.$validator.validate();
      if (isValidForm) {
        await this.saveItem();
      }
    },
    async saveItem() {
      // this.payload.prospecto.fechaEnvio = this.getDatetime();
      // this.payload.prospecto.fechaAsignacion = this.getDatetime();
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      await this.$http
        .post(route("Prospectos/postProspecto"), this.payload)
        .then(
          async response => {
            if (response.body.code === 200) {
              this.notifyMessage("success", this.$t("app.modules.candidates.headers.register_correct"));
              //this.correctSave = true;
            } else {
              //this.trubbleSave = true;
              this.notifyMessage("danger", this.$t("app.modules.candidates.headers.register_incorrect"));
            }
          },
          error => {
            //this.trubbleSave = true;
            this.notifyMessage("danger", this.$t("app.modules.candidates.headers.register_incorrect"));
          }
        )
        .finally(() => {});
        this.$swal.close();
    },
    async submit() {
      await this.saveItem();
    }
  }
};
</script>
<style scoped>
  h4 {
    font-weight: bold;
  }
  button {
    font-size: 16px;
    font-weight: bold;
    text-transform: uppercase;
  }
  .custom-row {
    margin-right: 0 !important;
  }
</style>
